import { useMemo } from 'react'
import { UseStoreDeliveryBread } from 'hooks/storeDeliveryBread/useStoreDeliveryBread'
import { isValidDefaultSchedules, isValidStoreDeliveryBread } from 'lib/validator'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useFilledDefaultRequiredForm = ({
  description,
  categoryId,
  isScheduledGeneration,
  isTypeDaily,
  dailySchedules,
  isTypePreorder,
  preorderSchedules,
  isTypeDelivery,
  storeDeliveryBreadForm,
}: {
  description: string
  categoryId: string
  isScheduledGeneration: boolean
  isTypeDaily: boolean
  dailySchedules: StoreDefaultScheduleType[]
  isTypePreorder: boolean
  preorderSchedules: StoreDefaultScheduleType[]
  isTypeDelivery: boolean
  storeDeliveryBreadForm: UseStoreDeliveryBread
}): boolean => {
  const isValidDailyType =
    !isTypeDaily || (isTypeDaily && isValidDefaultSchedules(dailySchedules, isScheduledGeneration))
  const isValidPreorderType = !isTypePreorder || (isTypePreorder && isValidDefaultSchedules(preorderSchedules, true))
  const isValidDeliveryType = !isTypeDelivery || (isTypeDelivery && isValidStoreDeliveryBread(storeDeliveryBreadForm))
  return useMemo(() => {
    return description !== '' && categoryId !== '' && isValidDailyType && isValidPreorderType && isValidDeliveryType
  }, [description, categoryId, isScheduledGeneration, isValidDailyType, isValidPreorderType, isValidDeliveryType])
}

export default useFilledDefaultRequiredForm
